export class Success {
  enabled: boolean = false;
  homeUrl: string;
  faqUrl: string;
  contactUrl: string;
  authenticationEntryPoint: string;

  constructor(options) {
    this.enabled = options.enabled || false;
    this.homeUrl = options.homeUrl;
    this.faqUrl = options.faqUrl;
    this.contactUrl = options.contactUrl;
    this.authenticationEntryPoint = options.authenticationEntryPoint;
  }
}
export class Configuration {
  success: Success;

  constructor(options) {
    this.success = new Success(options.success || {});
  }
}



// WEBPACK FOOTER //
// ./client/views/services/configuration.model.ts